<template>
    <AButton
        :title="title"
        type="primary"
        @click="btnDownload"
        :loading="state.loading">
        <i class="fa fa-file-excel-o" aria-hidden="true" v-if="!state.loading"></i>
        <span v-else>Downloading ...</span>
    </AButton>
</template>

<script>
import { defineComponent, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import apiClient from '@/services/axios'
import moment from 'moment'
import { isEmpty } from 'lodash';

export default defineComponent({
    props: {
        method: {
            default: () => 'get',
            type: String,
        },
        url: {
            default: () => '',
            type: String,
        },
        title: {
            default: 'download excel',
            type: String,
        },
        namefile: {
            default: () => '',
            type: String,
        },
        params: {
            default: () => ({}),
            type: Object,
        },
        export_by: {
            default: 'xls',
            type: String,
        },
    },
    setup: ( props, { emit } ) => {
        const route = useRoute()
        const state = reactive({
            namefile: props.namefile,
            loading: false,
            options: {
                responseType: 'blob',
                headers: {},
            },
        })

        const btnDownload = () => {
            state.loading = true

            let params = {
                ...props.params,
                _export: props.export_by,
            }

            let request = props.method === 'post'
                ? apiClient.post(props.url, params, state.options)
                : apiClient.get(props.url, { params: params, ...state.options })

            request.then(response => {
                    const url = URL.createObjectURL(
                        new Blob([response.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        }),
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `${state.namefile}_${moment().format('DDMMYY_HHmm')}.xlsx`,
                    )
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(async error => {
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = JSON.parse(await error.response.data.text()).message
                        emit('update:errors', `Kode error ${status}, ${statusText} : ${message}`)
                    }
                })
                .finally(() => {
                    state.loading = false
                })
        }

        onMounted(() => {
            // default namefile from meta title
            if (isEmpty(state.namefile)) {
                state.namefile = (route.meta.title_db ? route.meta.title_db : route.meta.title).replaceAll(' ', '-')
            }
        })

        return {
            btnDownload,
            state,
        }
    },
})
</script>
